import { green } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { FormattedMessage, useIntl } from "react-intl";
import { FaBtc } from "react-icons/fa";
import { useMemo } from "react";
import { WalletAddressStatus } from "@lib/types/Billing";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@lib/constants";
import { useTypedSelector } from "@lib/redux";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { useQuery } from "@tanstack/react-query";
import { apiGetBillingWalletAddress } from "@lib/api/wallet";
import { apiGetAIWalletAddress } from "@lib/api/walletAI";

type Props = {
  cardProps?: AppCardProps;
  type?: "billing" | "ai";
};

export default function WalletAddressMiniCard(props: Props) {
  const { cardProps, type = "billing" } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  const params = useMemo(() => {
    return {
      filter: [
        ...(selectedCustomer?.id
          ? [`customerId||eq||${selectedCustomer.id}`]
          : []),
      ],
    };
  }, [selectedCustomer]);

  const walletAddressQuery = useQuery({
    queryFn: () => apiGetBillingWalletAddress(params),
    queryKey: ["dashboard-minicard-walletAddress", JSON.stringify(params)],
    enabled: !!params && type === "billing",
  });
  const aiWalletAddressQuery = useQuery({
    queryFn: () => apiGetAIWalletAddress(params),
    queryKey: ["dashboard-minicard-aiWalletAddress", JSON.stringify(params)],
    enabled: !!params && type === "ai",
  });

  const { data, isLoading } =
    type === "billing" ? walletAddressQuery : aiWalletAddressQuery;
  const apiData = data?.data?.data || [];

  const total = apiData.length;
  const totalInUse = useMemo(() => {
    let count = 0;
    for (let index = 0; index < apiData?.length; index++) {
      if (apiData[index]?.status == WalletAddressStatus.InUse) {
        count += 1;
      }
    }
    return count;
  }, [apiData]);

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.CUSTOMER.WALLET_ACCOUNTS.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <FaBtc />,
        color: green[6],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.walletAddress"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: totalInUse,
            title: messages["enums.walletAddressStatus"][
              WalletAddressStatus.InUse
            ] as string,
          },
        },
      }}
    />
  );
}
